<script setup>
import { computed, onMounted, ref, reactive, onUpdated } from "vue"
import { useToast } from "vue-toastification"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"
import appConfig from "../../../app.config"
/* import Swal from "sweetalert2"; */
import Lottie from "@/components/widgets/lottie.vue"
import animationData from "@/components/widgets/msoeawqm.json"

import store from "../../state/store"
import ProductsTable from "./ProductsTable.vue"

// Get toast interface
const toast = useToast()

const page = ref({
  title: "محصولات",
  meta: [
    {
      name: "description",
      content: appConfig.description,
    },
  ],
})
const title = "مدیریت محصولات"
const items = ref([
  {
    text: "داشبورد",
    href: "/",
  },
  {
    text: "مدیریت محصولات",
    active: true,
  },
])

const DEFAULT_PRODUCT = {}

const products = computed(() => store.state.products)

const productModel = ref({})

function editProduct(cat) {
  store.dispatch("getProduct", cat.id).then(({ data }) => {
    productModel.value = data.data
    // showAddNewModal()
  })
}

const defaultOptions = ref({
  animationData: animationData,
})
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="productList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست محصولات</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                  <router-link
                    class="btn btn-success add-btn me-1"
                    id="create-btn"
                    :to="{ name: 'product.add' }"
                  >
                    <i class="ri-add-line align-bottom me-1"></i> افزودن محصول
                    جدید
                  </router-link>
                </div>
              </b-col>
            </b-row>
          </b-card-header>

          <!-- products table  -->

          <ProductsTable @clickEdit="editProduct" />

          <!-- add and edit product modal  -->

          <ProductModal
            v-model="showProductModal"
            :product="productModel"
            :products="products"
            @close="onModalClose"
          />
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.multiselect-clear {
  padding: 0 0 0 var(--ms-px, 0.875rem) !important;
}
.multiselect-caret {
  margin: 0 0 0 var(--ms-px, 0.875rem) !important;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem 0.5rem 2.7rem !important;
  background-position: left 0.9rem center !important;
}

.invalid-feedback {
  display: block !important;
}
</style>
